import { CurrentRfqStatusThemeModeConfig } from './types';

const light: CurrentRfqStatusThemeModeConfig = {
  currentRfqStatus: {},
};

export default light;
